"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSptCookieConsentClientNonAuth = void 0;
/**
 * A builder for SptCookieConsentClientNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for SptCookieConsentClientNonAuthEvent
 */
function createSptCookieConsentClientNonAuth(data) {
    return {
        name: 'SptCookieConsentClientNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createSptCookieConsentClientNonAuth = createSptCookieConsentClientNonAuth;
//# sourceMappingURL=createSptCookieConsentClientNonAuth.js.map